// @flow

export { analyzeLookAndFeelAgainstSpec } from './analyzer';
export type { LookAndFeelAnalysis } from './analyzer';
